import {
  Thermometer,
  Fan,
  Fire,
  Flame,
  Snowflake,
  Drop,
  Wrench,
  Sun,
} from "@phosphor-icons/react";

const MAP = { Thermometer, Fan, Fire, Flame, Snowflake, Drop, Wrench, Sun };

export default function ServiceIcon({ name, ...props }) {
  const Icon = MAP[name] || Flame;
  return <Icon {...props} />;
}
